<template>

	<div class="c-flight-panel__flight-information-filters-big">
		<div class="c-flight-panel__flight-information-toggles">

			<button id="ArrivalsButton"
					class="c-flight-panel__flight-information-toggle"
					:class="{ 'active': activeButton === 'Arrivals' }"
					@click="activeButton = 'Arrivals'; flightDirection()">
				Arrivals
			</button>

			<button id="DeparturesButton"
					class="c-flight-panel__flight-information-toggle"
					:class="{ 'active': activeButton === 'Departures' }"
					@click="activeButton = 'Departures'; flightDirection()">
				Departures
			</button>
		</div>
		<div class="c-flight-panel__flight-information-search">
			<span class="c-flight-panel__flight-information-search-button iconf-search"></span>
			<input class="c-flight-panel__flight-information-search-input" type="text" v-model="searchText" placeholder="Search your flight number" />
		</div>
		<div class="c-flight-panel__flight-information-radio">
			<form class="c-flight-panel__flight-information-radio-list">
				<div class="radios" v-for="(option,index) in options" :key="option.value">
					<input :name="this.status"
						   type="radio"
						   :id="option.value + this.status"
						   :value="option.value"
						   v-model="selectedOption"
						   @change="flightDirection">
					<label :for="option.value + this.status">{{ option.label }}</label>
				</div>
			</form>
		</div>
		<div class="c-flight-panel__flight-information-selects">

			<select v-model="selectedAirlineCategory">
				<option value="" selected>All Airlines</option>
				<option value="NZ">Air NZ</option>
				<option value="JQ">Jetstar</option>
				<option value="QF">Qantas</option>
				<option value="VA">Virgin Airlines</option>
				<option value="EK">Emirates Airlines</option>
			</select>

			<select id="date-select" v-model="selectedDate">
				<option v-for="dateOption in dateOptions" :value="dateOption.value" :key="dateOption.value">
					{{ dateOption.text }}
				</option>
			</select>

		</div>
	</div>
	<div class="c-flight-panel__flight-information-listing">

		<!-- Header Row -->
		<div class="c-flight-panel__flight-information-item">
			<div class="c-flight-panel__flight-information-flight">Flight No.</div>
			<div class="c-flight-panel__flight-information-origin" v-if="status === 'Arrival'">Arriving from</div>
			<div class="c-flight-panel__flight-information-origin" v-if="status === 'Departure'">Departing to</div>
			<div class="c-flight-panel__flight-information-time">Time</div>
			<div class="c-flight-panel__flight-information-status on-time">Status</div>
		</div>

		<!-- Loop through the filtered list of flights and display each one if has value-->
		<div v-for="item in filteredList" class="c-flight-panel__flight-information-item" v-if="filteredList.length > 0 && nodata === false">
			<div class="c-flight-panel__flight-information-flight">
				<div class="c-flight-panel__flight-information-airline">

					<img v-if="item.flightDesignation.includes('JQ')" src="../flags/ic-jetStar.png" alt="jetStar" />
					<img v-else-if="item.flightDesignation.includes('QF')" src="../flags/ic-qantas.png" alt="qantasTail" />
					<img v-else-if="item.flightDesignation.includes('VA')" src="../flags/ic-virgin.png" alt="virginTail" />
					<!--<img v-else-if="item.flightDesignation.includes('EK')" src="../flags/ic-emirates.png" alt="emirates" />-->
					<img v-else src="../flags/ic-airNz.png" alt="airNz" />

				</div>
				<div class="c-flight-panel__flight-information-number desktop-only">
					<div v-for="flight in item.flightList">{{flight}}</div>
				</div>
			</div>
			<div class="c-flight-panel__flight-information-number mobile-only">
				<div v-for="flight in item.flightList">{{flight}}</div>
			</div>
			<div class="c-flight-panel__flight-information-origin" v-if="status === 'Arrival'">{{item.from}}</div>
			<div class="c-flight-panel__flight-information-origin" v-if="status === 'Departure'">{{item.destination}}</div>

			<div class="c-flight-panel__flight-information-time"><span class="mobile-only">Time: </span> {{item.dateTime.format('HH:mm')}}</div>
			<div class="c-flight-panel__flight-information-status on-time">{{item.status}}</div>
		</div>

		<!-- Display if there are no flights to show -->
		<div v-else-if="nodata === false" class="c-flight-panel__flight-information-item">
			No flights found.
		</div>

		<div v-if="nodata" class="c-flight-panel__flight-information-item">
			Flights currently unavailable.
		</div>
	</div>
	<div class="c-flight-panel__flight-information-footer">
		<slot></slot>
		<p class="c-flight-panel__flight-information-text">
			Flight information is provided by third parties and its accuracy cannot be guaranteed by Queenstown Airport. For any delays or cancellations please contact the airlines directly to confirm as check-in times may remain the same.
		</p>
	</div>
	
    <div class="c-flight-updated">
        Last updated {{ lastUpdated }}
    </div>

</template>

<script>
	import { ref } from 'vue';
	import moment from 'moment';

	export default {
		name: 'flightinfo',
		props: {
			contactinfo: String,
			lastUpdated: String
		},
		data() {
			return {
				flightArrivalInfo: [],
				flightDepartureInfo: [],
				FlightList: [],
				carrier: '',
				status: '',
				direction: '',
				activeButton: 'Arrivals',
				options: [
					{ label: 'All', value: 'All' },
					{ label: 'Domestic', value: 'Domestic' },
					{ label: 'International', value: 'International' }
				],
				selectedOption: 'All',
				selectedAirlineCategory: '',
				searchText: '',
				timer: null,
				lastCallTime: null,
				selectedDate: null,
				dateOptions: [],
				nodata: false
			}
		},
		mounted() {
			// Call the method immediately upon component mount
			this.flightInfo();

			// Set up the interval to call method every 10 minutes (600,000 milliseconds)
			this.timer = setInterval(() => { this.flightInfo() }, 10 * 60 * 1000);
		},
		beforeUnmount() {
			// Clear the interval when the component is about to be unmounted to prevent memory leaks
			clearInterval(this.timer);
		},
		computed: {
			filteredList() {

				let flights = Array.from(this.FlightList);

				// Return the original list if the search box is empty
				if (!this.searchText && !this.selectedAirlineCategory && !this.selectedDate) {
					return flights;
				}

				// If searchText is not empty, filter the list
				if (this.searchText !== '') {
					// Otherwise, filter the list based on the searchText
					const searchTerm = this.searchText.toLowerCase();

					flights = flights.filter(item => {
						// Check if ANY of the object's string values contain the search term
						return Object.values(item).some(value => {
							// Only check string values and convert to lowercase for comparison
							if (typeof value === 'string') {
								return value.toLowerCase().includes(searchTerm);
							} else if (Array.isArray(value)) {
								var stringValue = value.join(' ').toLowerCase();
								return stringValue.includes(searchTerm);
							}
							return false;
						});
					});
				}

				// If selectedAirlineCategory is not empty, filter the list
				if (this.selectedAirlineCategory !== '') {
					flights = flights.filter(item => item.flightList.find(x => x.indexOf(this.selectedAirlineCategory) !== -1));
				}

				if (this.selectedDate !== '') {
					// Convert selectedDate to match the format in schDate (YYYY-MM-DD)
					const selectedDateString = new Date(this.selectedDate).toISOString().slice(0, 10);

					// Filter flights based on the selected date
					flights = flights.filter(item => {
						// Convert item.schDate to YYYY-MM-DD format for comparison
						const itemDateString = new Date(item.schDate).toISOString().slice(0, 10);
						return itemDateString === selectedDateString;
					});
				}

				return flights;
			},
		},
		methods: {
			async flightInfo() {

				// makes small helper function to convert date and time strings to Date object
				var MakeDate = (event) => {
					var date = event.estDate;
					var time = event.estTime.split('.')[0];
					// Use moment.js to parse and format the date and time
					var dateTime = moment(date + 'T' + time);

					event.dateTime = dateTime;

					return event;
				}

				// Fetch arrival flight data from the API
				const arrivalApi = '/api/flights/arrivals';

				try {
					const response = await fetch(arrivalApi); // Replace with your API endpoint
					if (!response.ok) {
						this.nodata = true;
						throw new Error(`HTTP error! status: ${response.status}`);
					}

					const data = await response.json();

					// Map new field to a full date and time
					this.flightArrivalInfo = data.map(x => MakeDate(x));

				} catch (error) {
					this.nodata = true;
					console.error('Error fetching data:', error);
				}

				// Fetch departure flight data from the API
				const departureApi = '/api/flights/departures';

				try {
					const response = await fetch(departureApi); // Replace with your API endpoint
					if (!response.ok) {
						this.nodata = true;
						throw new Error(`HTTP error! status: ${response.status}`);
					}

					const data = await response.json();

					// Map new field to a full date and time
					this.flightDepartureInfo = data.map(x => MakeDate(x));

				} catch (error) {
					this.nodata = true;
					console.error('Error fetching data:', error);
				}

				this.flightDirection();

			},
			flightDirection() {

				// Retrieve data for arrivals and departures
				let arrivals = this.flightArrivalInfo;
				let departures = this.flightDepartureInfo;

				// Get the URL's query string
				const queryString = window.location.search;

				// Create a URLSearchParams object to easily parse query parameters
				const urlParams = new URLSearchParams(queryString);

				// Check if the 'status' query parameter exists
				if (urlParams.has('status')) {
					// Get the value of the 'status' query parameter
					const statusValue = urlParams.get('status');

					// Set the component's data property 'status' to this value
					this.status = statusValue;
					this.activeButton = (statusValue === 'Arrival') ? 'Arrivals' : 'Departures';

					// Remove the query parameter from the URL without reloading the page
					window.history.replaceState(null, '', window.location.pathname);
				}

				// Determine which button is active and set FlightDetails accordingly
				if (this.activeButton === 'Arrivals') {
					this.flightLocal(arrivals);
					this.status = 'Arrival';
					this.direction = 'Arriving';
				}

				if (this.activeButton === 'Departures') {
					this.flightLocal(departures);
					this.status = 'Departure';
					this.direction = 'Departing';
				}

				this.generateDateOptions();
			},
			flightLocal(Flights) {

				// Filter FlightDetails based on the selected radio button option
				if (this.selectedOption === 'All') {

					this.flightSorted(Flights);

				} else if (this.selectedOption === 'Domestic') {

					this.flightSorted(Flights.filter(local => local.isDomestic === true));

				} else if (this.selectedOption === 'International') {

					this.flightSorted(Flights.filter(local => local.isDomestic === false));

				}
			},
			flightSorted(Flights) {

				// makes small helper function to convert date and time strings to Date object
				var MakeDate = (event) => {
					var date = event.schDate;
					var time = event.schTime.split('.')[0];
					var dateTime = (date + 'T' + time);

					return new Date(dateTime);
				}

				// Sorts the flights by date and time
				var Flightsorted = Flights.sort((a, b) => { return MakeDate(a) - MakeDate(b) });

				// Add flightDesignation field to each item in FutureFlights
				Flightsorted.forEach(item => {
					// Remove numbers using a regular expression
					const cleanedString = item.flightList[0].toString().replace(/[0-9]/g, '');
					// Add the new field to the item
					item.flightDesignation = cleanedString;
				});

				this.FlightList = Flightsorted;
			},
			generateDateOptions() {
				const today = new Date();
				const tomorrow = new Date(today);
				const dayAfter = new Date(today);

				tomorrow.setDate(today.getDate() + 1);
				dayAfter.setDate(today.getDate() + 2);

				this.dateOptions = [
					{ value: this.formatDateForValue(today), text: this.direction + ` (${moment(today).format('DD-MM-YYYY')})` },
					{ value: this.formatDateForValue(tomorrow), text: this.direction + ` (${moment(tomorrow).format('DD-MM-YYYY')})` },
					{ value: this.formatDateForValue(dayAfter), text: this.direction + ` (${moment(dayAfter).format('DD-MM-YYYY')})` },
				];

				// Optionally set today as the default selected date
				this.selectedDate = this.dateOptions[0].value;
			},
			formatDateForValue(date) {
				// Format as YYYY-MM-DD for consistency in the value
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
		},
	};
</script>
